import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { requisitionsHeaderStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsHeader";
import { requisitionsProductListStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsProductList";
import {requisitionsProductListLineStyles} from "@insite/content-library/Widgets/Requisitions/RequisitionsProductListLine";
import { requisitionsRequisitionLinesTableStyles } from "@insite/content-library/Widgets/Requisitions/RequisitionsRequisitionLinesTable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { GridOffset } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { StyledClickable } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

requisitionsRequisitionLinesTableStyles.table = {
    css: css`
        >thead{
            > tr[class^="DataTableHeadStyle"] {
                >${DataTableCellBase}{
                    border-bottom: 1px solid ${getColor("common.border")};
                    background: ${getColor("info.contrast")};
                    ${TypographyStyle}{
                        font-size: 16px;
                        color: ${getColor("primary")};
                    }
                }
            }
        }
        >tbody{
            > tr[class^="DataTableRowStyle"] {
                >${DataTableCellBase}{
                    font-size: 16px;
                    color: ${getColor("secondary")};
                    >${TypographyStyle}{
                        font-size: 16px;
                        color: ${getColor("secondary")};
                    }
                }
            }
        }
    `,
}

requisitionsProductListLineStyles.quantityHeadingAndText = {
    heading: {
        size: 14,
        css: css`
        color: ${getColor("secondary")};
        margin-bottom: 5px;
        font-weight: 500;
        `,
    },
    text: {
        css: css`
            color: ${getColor("secondary")};
        `,
    },
}

requisitionsProductListLineStyles.quantityGridItem = {
    width: [6, 4, 2, 2, 2]
}

requisitionsProductListLineStyles.subtotalGridItem = {
    width: [12, 4, 2, 2, 2],
    css: css`
        flex-direction: column;
    `,
}

requisitionsProductListLineStyles.subtotalWithoutVatHeadingAndText = {
    heading: {
        size: 14,
        css: css`
        color: ${getColor("secondary")};
        margin-bottom: 5px;
        font-weight: 500;
        `,
    },
    text: {
        weight: "bold",
        css: css`
            color: ${getColor("secondary")};
        `,
    },
}

requisitionsProductListLineStyles.subtotalHeadingAndText = {
    heading: {
        size: 14,
        css: css`
        color: ${getColor("secondary")};
        margin-bottom: 5px;
        font-weight: 500;
        `,
    },
    text: {
        weight: "bold",
        css: css`
            color: ${getColor("secondary")};
        `,
    },
}

requisitionsProductListLineStyles.productPriceStyles = {
    priceLabelText: {
        variant: "p",
        transform: "uppercase",
        size: 14,
    },
}

requisitionsProductListLineStyles.priceGridItem = { 
    width: [6, 4, 2, 2, 2],
    css: css`
    padding-top: 3px;
    >section[class^="sc"] {
        >${TypographyStyle}{
            margin-bottom: 0px;
            color: ${getColor("secondary")};
        }
        >div[class^="sc"] {
            >${TypographyStyle}{
                color: ${getColor("secondary")};
            }
        }
    }
    `
}

requisitionsProductListLineStyles.productPartNumbersStyles = { 
    erpNumberValueText: {
        css: css`
        color: ${getColor("secondary")};
        flex: 1 1 auto;
        min-width: 0;
        ${wrapInContainerStyles}
    `,
    }
}

requisitionsProductListLineStyles.descriptionGridItem = {
    width: [12, 12, 5, 6, 6],
    printWidth: 6,
    css: css`
        flex-direction: column;
        >${StyledClickable}{
            >${TypographyStyle}{
                color: ${getColor("secondary")};
                font-size: 16px;
                font-weight: 500;
            }
            &:hover{
                text-decoration: underline;
            }
        }
        >${GridItemStyle}{
            padding-left: 0px;
        }
    `,
}

requisitionsProductListLineStyles.mainContainer = {
    gap: 10,
    css: css`
        padding: 20px 0;
        border: 1px solid ${getColor("common.border")};
        margin-bottom: 15px;
        >${GridOffset}{
            width: 100%;
            margin: 0px;
        }
    `,
}

requisitionsProductListStyles.selectAllCheckbox = {
    css: css`
        margin-left: 20px;
        >${TypographyStyle}{
            font-size: 16px;
            color: ${getColor("secondary")};
        }
    `,
}

requisitionsProductListStyles.countText = {
    css: css`
        vertical-align: top;
        color: ${getColor("secondary")};
    `,
}

requisitionsHeaderStyles.titleText = {
    variant: "h1",
    css: css`
        @media print {
            font-size: 11px;
        }
    `,
}